<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5769 8.66211C7.76571 8.66215 7.94718 8.73963 8.08179 8.87793C8.21655 9.01639 8.29272 9.20506 8.29272 9.40234C8.2926 9.59945 8.21643 9.78744 8.08179 9.92578L6.98706 11.043L6.77026 11.2637H18.9929L19.1267 11.2842C19.2576 11.3173 19.3777 11.3888 19.4724 11.4912C19.5989 11.628 19.6699 11.81 19.6697 12V12.0371C19.6609 12.2207 19.5863 12.3944 19.4607 12.5234C19.3353 12.6521 19.1685 12.7274 18.9929 12.7363H6.77026L6.98706 12.957L8.08276 14.0742C8.14976 14.1425 8.20254 14.2245 8.23901 14.3145C8.27548 14.4044 8.29468 14.501 8.29468 14.5986C8.29466 14.6962 8.27548 14.7929 8.23901 14.8828C8.20259 14.9726 8.14958 15.0539 8.08276 15.1221L8.08179 15.123C8.01534 15.1919 7.936 15.2461 7.84937 15.2832C7.76286 15.3202 7.67039 15.3398 7.5769 15.3398C7.48328 15.3398 7.39009 15.3203 7.30347 15.2832C7.21699 15.2461 7.13837 15.1918 7.07202 15.123H7.07104L4.54272 12.5244H4.54175C4.47475 12.4561 4.42197 12.3741 4.3855 12.2842C4.34905 12.1943 4.32983 12.0976 4.32983 12C4.32986 11.9024 4.34904 11.8057 4.3855 11.7158C4.42192 11.6261 4.47494 11.5447 4.54175 11.4766L4.54272 11.4756L7.07104 8.87793C7.20569 8.73959 7.38805 8.66211 7.5769 8.66211Z"
      fill="#fff"
      stroke="#e1e1e1"
      stroke-width="0.26"
    />
    <path
      d="M5.427 17.5996H18.9993C19.3663 17.5998 19.6702 17.9071 19.6702 18.293V18.3789C19.6702 18.7648 19.3663 19.0721 18.9993 19.0723H5.427C5.05983 19.0722 4.7561 18.7649 4.7561 18.3789V18.293C4.7561 17.907 5.05983 17.5996 5.427 17.5996Z"
      fill="#fff"
      stroke="#e1e1e1"
      stroke-width="0.26"
    />
    <path
      d="M5.427 4.92969H18.9993C19.3663 4.92983 19.6702 5.23717 19.6702 5.62305V5.70898C19.6702 6.09486 19.3663 6.4022 18.9993 6.40234H5.427C5.05983 6.40232 4.7561 6.09493 4.7561 5.70898V5.62305C4.7561 5.2371 5.05983 4.92971 5.427 4.92969Z"
      fill="#fff"
      stroke="#e1e1e1"
      stroke-width="0.26"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
